module.exports = __webpack_public_path__ + "statics/img/new-bg-3a8cd2f3.png";


//////////////////
// WEBPACK FOOTER
// ./web/img/xhpopulrz/download/new-bg.png
// module id = 1210
// module chunks = 143